import React from "react";
import img from "../../assets/images/InceptionFinicallyLogo.png";

interface HeaderProps {
  children?: React.ReactNode;
}

const OnboardingHeader: React.FC<HeaderProps> = ({ children }) => {
  return (
    <header className="sticky top-0 z-50 w-full h-[80px] flex items-center px-10 bg-[#1C2537]">
      <div className="absolute left-0 right-0 flex justify-center pointer-events-none">
        <img src={img} alt="Inception Financial Logo" className="h-[60px] w-auto" />
      </div>

      <div>
        {children}
      </div>
    </header>
  );
};

export default OnboardingHeader;